var cbtUtil = require("../cbtUtil");

/**
 * @description It manages the dataLayer object that will be pushed as eeListView event.
 * @param {jQuery} carousel - product carousel
 * @param {String} listName - value that will appear as listName on the event
 * @return {Object} dataLayer object to be pushed
 */
function getHomePageProductListDataLayer(carousel, listName) {
    var $carousel = $(carousel);
    var $activeSlides = $carousel.find(".slick-slide.slick-active");
    var cbtAllPages = cbtUtil.parseJSON($(".cbt-all-pages").data("cbt-all-pages"));
    var dataLayer = {
        "event": "eeListView",
        "currencyCode": cbtAllPages && cbtAllPages.currencyCode ? cbtAllPages.currencyCode : "",
        "listName": listName,
        "listType": "Home",
        "products": []
    };
    $activeSlides.each(function(i, el) {
        var $element = $(el);
        var index = $element.data("slick-index");
        if (!$element.hasClass("slick-cloned") && !$element.hasClass("cbt-listed")) {
            $element.addClass("cbt-listed");
            var slideCbt = $element.find(".producttile-add-to-cart").attr("data-cbt");
            var cbtProduct = cbtUtil.parseJSON(slideCbt);
            //The GTM attribute products of cbtProduct only contains one product even though it is plural
            //The GTM attribute products of dataLayer will contain multiple products
            if (cbtProduct && cbtProduct.products) {
                //The index of slide will be saved so when the user switches tabs the information can be saved
                //If the user comes back to previous tab, this index list will prevent a push of already seen slides
                cbtProduct.products[0].position = index + 1;
                dataLayer.products.push(cbtProduct.products[0]);
            }
        }
    });
    return dataLayer;
}

module.exports = {
    getHomePageProductListDataLayer: getHomePageProductListDataLayer
};
